// @systeme: interface
// Dans Moi : l'adresse secrète du calendrier, à copier dans Google Agenda, Apple
// Calendrier, Thunderbird ou Outlook. Et le bouton pour la changer si elle a fuité.
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import type { FluxIcs } from '@foyer/shared';
import { api } from '../lib/api';
import { useMessages } from './Messages';

export function SectionCalendrier() {
  const { dire, direErreur } = useMessages();
  const [flux, setFlux] = useState<FluxIcs | undefined>();
  const [confirmer, setConfirmer] = useState(false);

  useEffect(() => {
    api.ics.lire().then(setFlux).catch(direErreur);
  }, [direErreur]);

  async function copier() {
    if (!flux) return;
    try {
      await navigator.clipboard.writeText(flux.url);
      dire('Adresse copiée. Colle-la dans ton application de calendrier.');
    } catch {
      dire('Sélectionne l’adresse et copie-la à la main.');
    }
  }

  async function regenerer() {
    try {
      setFlux(await api.ics.regenerer());
      setConfirmer(false);
      dire(
        'Nouvelle adresse. L’ancienne ne marche plus : pense à la remplacer dans ton calendrier.',
      );
    } catch (e) {
      direErreur(e);
    }
  }

  if (!flux) return null;

  return (
    <Box>
      <Typography variant="h2" component="h2" gutterBottom>
        Mon calendrier
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 1.5 }}>
        Pour voir tout le foyer dans Google Agenda, Apple Calendrier, Thunderbird ou Outlook : colle
        cette adresse comme « calendrier par abonnement ». Elle est secrète, rien de privé n’y
        passe.
      </Typography>
      <Stack spacing={1.5}>
        <TextField
          value={flux.url}
          InputProps={{ readOnly: true }}
          inputProps={{ 'aria-label': 'Adresse du calendrier' }}
          onFocus={(e) => e.target.select()}
        />
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Button variant="outlined" onClick={() => void copier()}>
            Copier l’adresse
          </Button>
          {confirmer ? (
            <>
              <Button color="error" variant="contained" onClick={() => void regenerer()}>
                Oui, changer
              </Button>
              <Button color="inherit" onClick={() => setConfirmer(false)}>
                Annuler
              </Button>
            </>
          ) : (
            <Button color="inherit" onClick={() => setConfirmer(true)}>
              Changer l’adresse
            </Button>
          )}
        </Stack>
        {flux.derniereLectureLe && (
          <Typography variant="body2" color="text.secondary">
            Un calendrier l’a lue récemment : c’est bien branché.
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
